import { f as a } from "./index758.mjs";
import { g as s } from "./index767.mjs";
var l = a, o = s, t = o.RegExp, f = l(function() {
  var r = t(".", "s");
  return !(r.dotAll && r.test(`
`) && r.flags === "s");
});
export {
  f as r
};
